module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/woman_holding_phone@2x-f4c2150a3c29e1d4b76ecf7cee2b6600.png";